import {Component, OnInit, ViewChild} from '@angular/core';
import {ConfirmationService, ConfirmEventType, MessageService} from 'primeng/api';
import {DatePipe, KeyValue} from '@angular/common';
import {Paginator} from 'primeng/paginator';
import {Router} from '@angular/router';
import {Platform} from '@angular/cdk/platform';
import {CacheService} from '../@shared/services/cache.service';
import * as FileSaver from 'file-saver';
import {InvoiceAndSoaService} from '../@shared/new-services/invoice-and-soa.service';

@Component({
    selector: 'app-statement-of-accounts',
    templateUrl: './statement-of-accounts.component.html',
    styleUrls: ['./statement-of-accounts.component.scss']
})
export class StatementOfAccountsComponent implements OnInit {

    @ViewChild('pagination') pagination: Paginator;
    filteredStatements: any;
    statements: any;
    isLoading = false;
    clearFilter = false;
    searchInvoiceStatement = '';
    currentStatus = 'All';
    statementFilterValue: any = {
        filterByIdentifier: null,
        unPaidBoolean: false,
        partiallyPaidBoolean: false,
        overDueBoolean: false,
        currencyCode: '',
        businessEntityId: ''
    };
    currencySelection = [];
    selectedCurrency: any;
    countStats: any;
    selectedView: any = 0;
    isFileDownloading: boolean;
    selectedSOACustomer = '';

    constructor(private cacheService: CacheService,
                private messageService: MessageService,
                private router: Router, public platform: Platform,
                private confirmationService: ConfirmationService,
                private invoiceAndSoaService: InvoiceAndSoaService,
    ) {
    }

    ngOnInit(): void {
        this.getCurrencyCode();
    }

    orderOriginal = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
        return 0;
    };


    refreshSOA() {
        this.isLoading = true;
        this.invoiceAndSoaService
            .refreshSOA(this.selectedSOACustomer)
            .subscribe((x) => {
                if (x?.message === 'Success') {
                    this.isLoading = false;
                    this.getCurrencyCode();
                    this.getSoaCountStats();
                }

                // tslint:disable-next-line:no-shadowed-variable
            }, (error) => {
                this.messageService.add({
                    summary: 'State of Accounts',
                    severity: 'error',
                    detail: error?.message ? error?.message : error,
                    key: 'soa-message'
                });
                this.isLoading = false;
            });
    }


    getFilteredAccountStatement(page = 0, size = 10, filterObj?: any) {
        this.statements = [];
        this.filteredStatements = [];
        this.isLoading = true;
        this.invoiceAndSoaService
            .getFilteredStatements(page, size, filterObj)
            .subscribe(
                (x) => {
                    this.isLoading = false;
                    this.statements = x;
                    this.filteredStatements = x;
                },
                // tslint:disable-next-line:no-shadowed-variable
                (error) => {
                    this.isLoading = false;
                    this.messageService.add({
                        summary: 'State of Accounts',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'soa-message'
                    });
                }
            );
    }

    getCurrencyCode() {
        this.invoiceAndSoaService.getCurrencyCode(this.selectedSOACustomer)
            .subscribe((res) => {
                this.selectedCurrency = res[0];
                this.statementFilterValue.currencyCode =
                    this.statementFilterValue?.filterByIdentifier?.length === 0 ? this.selectedCurrency
                        : '';
                this.getFilteredAccountStatement(0, 10, this.statementFilterValue);
                this.getSoaCountStats();
                this.currencySelection = res;
            }, error => {
                console.log(error);
            });
    }

    getSoaCountStats() {
        // this.isLoading = true;
        this.invoiceAndSoaService
            .getSoaCountStatistics(this.selectedSOACustomer)
            .subscribe(
                (x) => {
                    // this.isLoading = false;
                    this.countStats = x;
                },

                (error) => {
                    // this.isLoading = false;
                    this.messageService.add({
                        summary: 'State of Accounts',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'soa-message'
                    });
                }
            );
    }


    paginateFilteredStatements(paginateData: any) {
        this.getFilteredAccountStatement(paginateData?.page, 10, this.statementFilterValue);
    }

    applyFilterToStatements(data: any) {
        this.statementFilterValue = data?.filterValue;
        this.selectedSOACustomer = this.statementFilterValue.businessEntityId;
        this.searchInvoiceStatement = this.statementFilterValue?.filterByIdentifier;
        if (this.statementFilterValue?.filterByIdentifier?.length === 0) {
            console.log(this.statementFilterValue?.filterByIdentifier?.length + 'ZERO');
            this.statementFilterValue.currencyCode = this.selectedCurrency;
        } else {
            this.selectedCurrency = null;
            this.statementFilterValue.currencyCode = null;
        }
        if (this.statementFilterValue?.unPaidBoolean) {
            this.currentStatus = 'Unpaid';
        } else if (this.statementFilterValue?.partiallyPaidBoolean) {
            this.currentStatus = 'Partially Paid';
        } else {
            this.currentStatus = 'All';
        }
        this.getCurrencyCode();
        // this.getFilteredAccountStatement(0, 10, this.statementFilterValue);
    }


    clearAllFilter() {
        this.clearFilter = false;
        this.searchInvoiceStatement = null;
        this.currentStatus = 'All';
        this.getFilteredAccountStatement();
        this.pagination.changePage(0);
    }

    navigateToDocuments(soa: any) {
        this.router.navigate(['/', 'documents-listing'],
            {
                queryParams: {
                    documentType: 'SOA',
                    documentNumber: soa?.invoiceNumber,
                    documentTypeGid: soa?.invoiceGid,
                    bookingId: soa?.bookingId
                }
            }
        );
    }

    applyCurrencyFilter(data: any) {
        this.filteredStatements = null;
        this.statements = null;
        this.statementFilterValue.currencyCode = data.value;
        this.getFilteredAccountStatement(0, 10, this.statementFilterValue);
        this.pagination.changePage(0);
    }

    handleCardViewActions(data: any) {
        if (data.actionFrom === 'view-document') {
            this.navigateToDocuments(data.statement);
        }
    }

    featureNotAvailable() {
        this.messageService.add({
            summary: 'Feature Message !',
            severity: 'info',
            detail: 'Feature will be available soon',
            key: 'soa-message',
        });
    }

    downloadFiles(fileType: string) {
        this.confirmationService.confirm({
            message: 'Select the option to download file.',
            header: 'Download Options',
            icon: 'pi pi-download',
            accept: () => {
                // Download the current page only.
                if (fileType === 'pdf') {
                    this.invoiceAndSoaService?.getFilteredStatements(0, 10, this.statementFilterValue)
                        .subscribe((x) => {
                            this.exportPdf(x?.content);
                        });
                } else if (fileType === 'excel') {
                    this.invoiceAndSoaService?.getFilteredStatements(0, 10, this.statementFilterValue)
                        .subscribe((x) => {
                            this.exportExcel(x?.content);
                        });
                }
            },
            reject: (type) => {
                switch (type) {
                    case ConfirmEventType.REJECT:
                        // Download All Pages
                        this.isFileDownloading = true;
                        this.invoiceAndSoaService?.getFilteredStatements(0, 10000, this.statementFilterValue)
                            .subscribe((x) => {
                                this.isFileDownloading = false;
                                if (fileType === 'pdf') {
                                    this.exportPdf(x?.content);
                                } else if (fileType === 'excel') {
                                    this.exportExcel(x?.content);
                                }
                            });
                        break;
                    case ConfirmEventType.CANCEL:
                        // Closed dialog box without any options to download.
                        break;
                }
            }
        });
    }

    exportExcel(dataContent: any) {
        const exportedBookings = this.exportedColumnsForFileDownload(dataContent);
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(exportedBookings);
            const workbook = {Sheets: {data: worksheet}, SheetNames: ['data']};
            const excelBuffer: any = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
            this.saveAsExcelFile(excelBuffer, 'statements');
        });
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }

    exportPdf(dataContent: any) {
        const cols = [
            {field: 'invoiceNumber', header: 'Invoice Number'},
            {field: 'billToPartyName', header: 'Bill To'},
            {field: 'transportDocument', header: 'Transport Document'},
            {field: 'invoiceDate', header: 'Invoice Date'},
            {field: 'dueDate', header: 'Due Date'},
            {field: 'invoiceCurrency', header: 'Currency'},
            {field: 'formattedInvoiceAmount', header: 'Amount'},
            {field: 'formattedTransactionalAmount', header: 'Transactional Amount'},
            {field: 'formattedDueAmount', header: 'Due'},
            {field: 'status', header: 'Status'},
        ];
        const exportedColumns = cols.map(col => (
            {title: col.header, dataKey: col.field}
        ));

        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(x => {

                // @ts-ignore
                const doc = new jsPDF.default({
                    orientation: 'landscape',
                });
                doc.text('Statement of Accounts', 15, 10);
                // @ts-ignore
                doc.autoTable(exportedColumns, dataContent, {
                    theme: 'grid',

                    columnStyles: {
                        0: {
                            columnWidth: 30
                        },
                        1: {
                            columnWidth: 35
                        },
                        2: {
                            columnWidth: 35
                        },
                        3: {
                            columnWidth: 30
                        },
                        4: {
                            columnWidth: 30
                        },
                        5: {
                            columnWidth: 20
                        },
                        6: {
                            columnWidth: 25
                        },
                        7: {
                            columnWidth: 25
                        },
                        8: {
                            columnWidth: 25
                        },
                        9: {
                            columnWidth: 15
                        },
                    },
                    headerStyles: {
                        theme: 'grid',
                        fillColor: '#3f51b5',
                    },
                });
                doc.save('statements.pdf');
            });
        });
    }


    exportedColumnsForFileDownload(dataContent: any) {
        const datePipe = new DatePipe('en-US');
        const exportedStatements = dataContent?.map((statement) => {
            const exportStatement = {
                'Invoice Number': statement?.invoiceNumber ? statement?.invoiceNumber : '-',
                'Bill To': statement?.billToPartyName ? statement?.billToPartyName : '-',
                'Transport Document': statement?.transportDocument ? statement?.transportDocument : '-',
                'Invoice Date': statement?.invoiceDate ? datePipe.transform(statement?.invoiceDate, 'dd-MMM-yyyy') : '-',
                'Due Date': statement?.dueDate ? datePipe.transform(statement?.dueDate, 'dd-MMM-yyyy') : '-',
                Currency: statement?.invoiceCurrency ? statement?.invoiceCurrency : '-',
                Amount: statement?.formattedInvoiceAmount ? statement?.formattedInvoiceAmount : '-',
                'Transactional Amount': statement?.formattedTransactionalAmount ? statement?.formattedTransactionalAmount : '-',
                Due: statement?.formattedDueAmount ? statement?.formattedDueAmount : '-',
                Status: statement?.status ? statement?.status : '-'
            };
            return exportStatement;
        });
        return exportedStatements;
    }

}
